/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IToysrusEidboxArViewProps } from './toysrus-eidbox-ar';

export default (props: IToysrusEidboxArViewProps) => {
    return (
        <>
            <div className="eidbox-header"></div>
            <div className="eidbox-header-text">اصنع صندوق هدايا العيد</div>
            <div className="eidbox-body">
                {props.isAgeSelected 
                ?
                <div className="gift-finder-budgetcontainer" id="gift-finder-budgetcontainer">
                    <div className="giftfinder-lable"> حدد الفئة العمرية</div>
                    <div className="giftfinder-currency">
                       
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    {
                        props.ageGroups && props.ageGroups.map( ag => (
                            <div className={ag.containerClassName}>
                            <label className="gift-finder-container">{ag.ageLabel}
                                <input name="color" type="radio" value={ag.ageValue} id={ag.id} checked={ag.isChecked} onChange={props.onAgeInput}/>
                                <span className="gift-finder-checkmark"></span>
                            </label>
                            </div>
                        ))
                    }
                    <br/>
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                    <button onClick={props.getGiftSuggestions} type="button" className="giftfinder-button gift-finder-green-button">احصل على اقتراحات</button>
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                    <button onClick={props.giftfinderBack} type="button" className="giftfinder-button">العودة</button>
                </div>
                :
                <div className="eidbox-agecontainer"  id="Giftfinder-agecontainer">
                    <br/>
                    <br/>
                    <div className="giftfinder-lable">أختر التصنيف</div>
                    <br/>
                    <br/>
                    {
                        props.genderGroups && props.genderGroups.map( gd => (
                            <div className={gd.containerClassName}>
                            <label className="gift-finder-container">{gd.genderLabel}
                                <input name="gender" type="radio" value={gd.genderValue} id={gd.id} checked={gd.isChecked} onChange={props.onGenderInput}/>
                                <span className="gift-finder-checkmark"></span>
                            </label>
                            </div>
                        ))
                    }
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                    <div className="toysfinder-btn-col">
                        <button onClick={props.giftfinderNext} type="button" className="giftfinder-button"> التالي</button>
                    </div>
                    <br/>
                    <br className="clr-bth"/>
                    <br/>
                </div>
                }
            </div>
        </>
    );
};
